export const formatLink = link => {
  if (typeof link !== 'string') return link;
  return link?.match(/^http(s)?:\/{2}.*$/g) ? link : `https://${link}`;
};
